import _ from 'underscore';
import { InsertionOrderUtils } from '@bingads-webui-clientcenter/entity-utils';
import { InsertionOrderSearchFields, InsertionOrderFieldKeys, MismatchedReasonCode } from './constants';

const {
  isUnlimitedIOBudget,
  formatUnlimitedIOBudgetInGrid,
  formatEndlessIOEndDateInGrid,
} = InsertionOrderUtils;

export function formatCurrency({
  i18n, value, currencyCode, options,
}) {
  return i18n.formatCurrency(value, currencyCode, options);
}

export function parseDecimal({ i18n, value }) {
  return _.isString(value) ? i18n.parseDecimal(value) : value;
}

export function formatDecimalToFixed({ i18n, value }) {
  const parsedValue = parseDecimal({ i18n, value });
  return _.isNumber(parsedValue) ? i18n.formatDecimalToFixed(parsedValue) : parsedValue;
}

export function getMismatchedInfoString({ i18n, mismatchedReason, mismatchedAmountString }) {
  switch (mismatchedReason) {
    case MismatchedReasonCode.AdjustmentMismatch:
      return i18n.getString(
        _TL_('This amount of {{mismatchedAmount}} doesn’t  match the IO Report, as no active IO could be found to support this adjustment.'),
        { mismatchedAmount: mismatchedAmountString },
      );
    default:
      return '';
  }
}

export function formatInsertionOrderLabel({
  i18n,
  orderName,
  seriesName,
  startDate,
  endDate,
  budget,
}) {
  let formattedName = '';
  if (!_.isEmpty(orderName)) {
    formattedName = `${orderName}, `;
  } else if (!_.isEmpty(seriesName)) {
    formattedName = `${seriesName}, `;
  }
  // Follow the formatter in insertion order page
  const formattedBudget = formatUnlimitedIOBudgetInGrid({ i18n, spendCapAmountValue: budget, unlimitedStringKey: _TL_('Unlimited') });
  const formattedEndDate = formatEndlessIOEndDateInGrid({ i18n, endDateValue: endDate && i18n.parseDate(endDate), noEndDateStringKey: _TL_('No End Date') });
  return `${formattedName}${startDate} - ${formattedEndDate}, ${formattedBudget}`;
}

export function getSelectorButtonDescription({ i18n, selectedInsertionOrders }) {
  if (_.isEmpty(selectedInsertionOrders)) {
    return i18n.getString(_TL_('All insertion orders (IOs)'));
  }
  if (selectedInsertionOrders.length === 1) {
    return selectedInsertionOrders[0].name;
  }
  return i18n.getString(_TL_('Multiple insertion orders'));
}

export function getSearchBarPlaceholder({ i18n, searchField }) {
  switch (searchField) {
    case InsertionOrderSearchFields.FriendlyName:
      return i18n.getString(_TL_('Search insertion order name'));
    case InsertionOrderSearchFields.SeriesName:
      return i18n.getString(_TL_('Search series name'));
    default:
      return i18n.getString(_TL_('Search insertion order name, series name'));
  }
}

export function getSearchFieldOptions() {
  return _.keys(InsertionOrderSearchFields).map(key => ({
    key,
    value: InsertionOrderSearchFields[key],
    labelKey: InsertionOrderFieldKeys[key],
  }));
}

export function getBudgetChangeString({ i18n, rawValue, amountValue, useEmptyString = false }) {
  if (isUnlimitedIOBudget(Number(rawValue))) {
    return useEmptyString ? '--' : i18n.getString(_TL_('Unlimited'));
  }
  return amountValue;
}
